import { render, staticRenderFns } from "./Industries.vue?vue&type=template&id=1b9203cb&scoped=true&"
import script from "./Industries.vue?vue&type=script&lang=js&"
export * from "./Industries.vue?vue&type=script&lang=js&"
import style0 from "./Industries.vue?vue&type=style&index=0&id=1b9203cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9203cb",
  null
  
)

export default component.exports